import Glide from '@glidejs/glide';

window.Glide = Glide;